import { type PropType } from "vue";

export type StepStatus = "wait" | "process" | "finish";

export const stepItemProps = {
  name: {
    type: [String, Number],
    require: true,
    default: "",
  },
  modelValue:{
    type:String as PropType<StepStatus>,
    default:'wait'
  },
  title: {
    type: String,
    default: "",
  },
};

export const stepItemEmits = {
  "update:modelValue": (val: StepStatus) => true,
};
